import React, {FC, RefObject} from 'react';

import {HandlerOf, MouseEventHandler} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {InboxesSearchQueryBuilderButton} from './inboxesSearchQueryBuilderButton';
import {InboxesSearchQueryBuilderDropdownContainer} from './inboxesSearchQueryBuilderDropdownContainer';
import {useInboxesSearchQueryBuilderForm} from './useInboxesSearchQueryBuilderForm';

/*
 * Props.
 */

interface InboxesSearchQueryBuilderProps {
  searchQuery?: string;
  queryHash?: string;
  namespace?: string;
  isOpen: boolean;
  hasFocus: boolean;

  searchBarWrapperRef: RefObject<HTMLDivElement>;
  dropdownRef: RefObject<HTMLDivElement>;

  toggleDropdown: HandlerOf<boolean>;
  onSearch: HandlerOf<string>;
  onMouseDown: MouseEventHandler;
}

/*
 * Component.
 */

export const InboxesSearchQueryBuilder: FC<InboxesSearchQueryBuilderProps> = (props) => {
  const {
    searchQuery,
    queryHash,
    namespace,
    searchBarWrapperRef,
    isOpen,
    toggleDropdown,
    onSearch,
    dropdownRef,
    onMouseDown,
    hasFocus,
  } = props;

  const queryBuilderForm = useInboxesSearchQueryBuilderForm({
    searchQuery: searchQuery ?? '',
    namespace,
    queryHash,
  });

  return (
    // Stop onBlur events from propagating to the SearchBar component (and InboxesSearchBarContent's onSearchBarBlur)
    // now that this component is part of its "right content".
    <div role="presentation" onBlur={(e) => e.stopPropagation()}>
      <InboxesSearchQueryBuilderButton
        hasFocus={hasFocus}
        isOpen={isOpen}
        onMouseDown={onMouseDown}
        onClick={() => toggleDropdown(false)}
      />
      {isOpen && (
        <InboxesSearchQueryBuilderDropdownContainer
          innerRef={dropdownRef}
          anchor={searchBarWrapperRef}
          width={searchBarWrapperRef.current?.clientWidth}
          searchQuery={searchQuery}
          queryHash={queryHash}
          onClose={toggleDropdown}
          onSearchClick={onSearch}
          queryBuilderForm={queryBuilderForm}
        />
      )}
    </div>
  );
};
